import appConfig from '../../config/appConfig';
import parentalProtectionService from '../parentalProtectionService';
import iotDeviceConfig from './iotDeviceConfig';

const isGlobalHolderCheck = (iotDevice) => getGlobalConfig(iotDevice).is_holder_check;
const isGlobalAutoStart = (iotDevice) => getGlobalConfig(iotDevice).is_autostart && appConfig.getIsAutoStartEnabled();
const isGlobalFlexPuff = (iotDevice) => getGlobalConfig(iotDevice).is_flex_puff && appConfig.getIsFlexPuffEnabled();
const isGlobalLedIntensity = (iotDevice) => getGlobalConfig(iotDevice).is_led_intensity && appConfig.getIsLedEnabled();
const isGlobalExtendedLedIntensity = (iotDevice) =>
    getGlobalConfig(iotDevice).is_extended_led_intensity && appConfig.getIsLedEnabled();
const isGlobalAdvancedDiagnostic = (iotDevice) => {
    const isEnabledInGlobalConfig = getGlobalConfig(iotDevice).is_advanced_diagnostic;
    const isEnabledInAppConfig = appConfig.getIsAdvancedDeviceDiagnosticEnabled(iotDevice?.device?.type);

    return isEnabledInGlobalConfig && isEnabledInAppConfig;
};
const isGlobalConnectCare = (iotDevice) =>
    getGlobalConfig(iotDevice).is_connect_care && appConfig.getIsConnectCareEnabled(iotDevice?.device?.type);
const isGlobalVibration = (iotDevice) => getGlobalConfig(iotDevice).is_vibration && appConfig.getIsVibrationEnabled();
const isGlobalSelfCleaning = (iotDevice) =>
    getGlobalConfig(iotDevice).is_self_cleaning && appConfig.getIsSelfCleaningEnabled();
const isGlobalDeviceAlarm = (iotDevice) =>
    getGlobalConfig(iotDevice).is_device_alarm && appConfig.getIsDeviceAlarmEnabled();
const isGlobalStatusGestures = (iotDevice) =>
    getGlobalConfig(iotDevice).is_status_gestures && appConfig.getIsGestureEnabled();
const isGlobalParentProtection = (iotDevice) =>
    parentalProtectionService.getIsLocked(getGlobalConfig(iotDevice).is_parent_protection);
const isGlobalCountdown = (iotDevice) => getGlobalConfig(iotDevice).is_countdown;
const isGlobalSessionProfiling = (iotDevice) =>
    getGlobalConfig(iotDevice).is_session_profiling && appConfig.getIsSessionProfilingEnabled();
const isGlobalVapeCloudSize = (iotDevice) =>
    getGlobalConfig(iotDevice).is_vape_cloud_size && appConfig.getIsVapeCloudSizeEnabled();
const isGlobalResponsiveDraw = (iotDevice) =>
    getGlobalConfig(iotDevice).is_responsive_draw && appConfig.getIsResponsiveDrawProfileEnabled();
const isGlobalReset = (iotDevice) => getGlobalConfig(iotDevice).is_reset && appConfig.getIsDeviceResetFeatureEnabled();
const isGlobalAemFlexBattery = (iotDevice) =>
    getGlobalConfig(iotDevice).is_aem_flex_battery && appConfig.getIsAemFlexBatteryEnabled();
const isGlobalAemPauseMode = (iotDevice) =>
    getGlobalConfig(iotDevice).is_aem_pause_mode && appConfig.getIsAemFlexBatteryEnabled();

const getGlobalConfig = (iotDevice) => iotDeviceConfig.getGlobalFeaturesConfig(iotDevice);

export default {
    isGlobalHolderCheck,
    isGlobalCountdown,
    isGlobalAutoStart,
    isGlobalDeviceAlarm,
    isGlobalLedIntensity,
    isGlobalExtendedLedIntensity,
    isGlobalParentProtection,
    isGlobalSelfCleaning,
    isGlobalSessionProfiling,
    isGlobalStatusGestures,
    isGlobalVibration,
    isGlobalAdvancedDiagnostic,
    isGlobalVapeCloudSize,
    isGlobalResponsiveDraw,
    isGlobalReset,
    isGlobalConnectCare,
    isGlobalAemFlexBattery,
    isGlobalAemPauseMode,
    isGlobalFlexPuff,
};
